import { render, staticRenderFns } from "./NotAllowed.vue?vue&type=template&id=0f0d5197&scoped=true"
import script from "./NotAllowed.vue?vue&type=script&lang=js"
export * from "./NotAllowed.vue?vue&type=script&lang=js"
import style0 from "./NotAllowed.vue?vue&type=style&index=0&id=0f0d5197&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0d5197",
  null
  
)

export default component.exports